import { render } from "./Home.vue?vue&type=template&id=fadf8f5e"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/Users/new/workspace_git/mga/mga-qr-custom-movie-magic/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])